<!-- <app-asset-list-header
  [title]="'SIDENAV.WORKFLOW_CONFIGURATION'"
  [hideAddNew]="false"
  [addNewText]="'COMMON.MODULE'"
  [hideDropdown]="true"
  (addNewClicked)="goToAddNewModule()"
></app-asset-list-header> -->

<header>
    <div class="title-container">
        <h2>Workflow Configuration</h2>
        <h5>Powering Connectivity, Empowering Operations</h5>
    </div>    
    <div class="add-new-container">
        <button (click)="goToAddNewModule()">Add New Module</button>
    </div>
</header>
<div class="filter-bar">
  <div class="search-bar">
    <img src="assets/icons/search.svg" alt="Search icon" class="search-icon" />
    <input
      type="text"
      class="search-input"
      [placeholder]="'COMMON.SEARCH' | translate"
    />
  </div>
</div>

<div class="content-body" style="gap: 1rem">
    <app-workflow-card
        [imgUrl]="'../../../../assets/icons/v3-bps/asset-management-main.svg'"
        [cornerIcon]="'../../../../assets/icons/v3-bps/asset-management-corner-icon.svg'"
        [color]="'#0C2A58'"
        [title]="'Asset Management'"
        [text]="'Seamless Management of utility assets for improved efficiency'">
    </app-workflow-card>
    <app-workflow-card
        [imgUrl]="'../../../../assets/icons/v3-bps/meter-management-main.svg'"
        [cornerIcon]="'../../../../assets/icons/v3-bps/meter-management-corner-icon.svg'"
        [color]="'#451759'"
        [title]="'Meter Management'"
        [text]="'Seamless Management of utility assets for improved efficiency'">
    </app-workflow-card>
    <app-workflow-card 
        [imgUrl]="'../../../../assets/icons/v3-bps/operations-management-main.svg'" 
        [cornerIcon]="'../../../../assets/icons/v3-bps/operations-management-corner-icon.svg'"
        [color]="'#6E2B19'"
        [title]="'Operations Management'"
        [text]="'Seamless Management of utility assets for improved efficiency'">
    </app-workflow-card>
    <app-workflow-card 
        [imgUrl]="'../../../../assets/icons/v3-bps/readings-main.svg'" 
        [cornerIcon]="'../../../../assets/icons/v3-bps/readings-corner-icon.svg'"
        [color]="'#03170C'"
        [title]="'Readings'"
        [text]="'Seamless Management of utility assets for improved efficiency'">
    </app-workflow-card>
    <app-workflow-card
        *ngFor="let module of data"
        [imgUrl]="module.imagePath"
        [cornerIcon]="module.iconPath"
        [color]="module.color"
        [title]="module.name"
        [text]="module.description"
        [isDynamic]="true">
  </app-workflow-card>
</div>
